import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpandableContainerComponent } from './expandable-container.component';
import { WmCardModule } from '../card/index';

@NgModule({
	declarations: [ExpandableContainerComponent],
	imports: [CommonModule, WmCardModule],
	exports: [ExpandableContainerComponent]
})
export class WmExpandableContainerModule {}
